/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { Breadcrumb, Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ScreenTitle from 'common/components/screenTitle/ScreenTitle';
import DeviceBrandsScreen from './deviceBrands/DeviceBrandsScreen';
import DeviceModelsScreen from './deviceModels/DeviceModelsScreen';
import { useSearchParams } from 'react-router-dom';

type Props = {
};

const ConfigDevicesScreen: React.FC<Props> = () => {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get('tab') === 'models' ? 'models' : 'brands';

    const onTabSelect = (key: string | null) => {
        if (!key) return;
        setSearchParams({ tab: key }, { replace: true });
    };

    return (
        <ScreenTitle title={t('config_devices.title')}>
            <Breadcrumb>
                <Breadcrumb.Item active>{t('config_devices.title')}</Breadcrumb.Item>
            </Breadcrumb>
            <Tabs activeKey={activeTab} onSelect={onTabSelect} className="mb-3" fill>
                <Tab eventKey="brands" title={t('config_devices.brands.title')}>
                    <DeviceBrandsScreen />
                </Tab>
                <Tab eventKey="models" title={t('config_devices.models.title')}>
                    <DeviceModelsScreen />
                </Tab>
            </Tabs>
        </ScreenTitle>
    );
};

export default ConfigDevicesScreen;
